import { render, staticRenderFns } from "./DoKubDetailSubGrid.vue?vue&type=template&id=af46e98a&"
import script from "./DoKubDetailSubGrid.vue?vue&type=script&lang=js&"
export * from "./DoKubDetailSubGrid.vue?vue&type=script&lang=js&"
import style0 from "./DoKubDetailSubGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports